const BLUR_COLORS = {
    yellow: "#FAEF76",
    orange: "#FF9F54",
    pink: "#FFCAF6",
    green: "#8DDA8F",
    blue: "#B4E2FF",
} as const

type BlurColor = keyof typeof BLUR_COLORS

interface BlurShapeProps {
    width?: string;
    height?: string;
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
    translateX?: string;
    translateY?: string;
    color?: BlurColor;
    className?: string;
}

export default function BlurShape({width = "500px", height = "500px", top, bottom, left, right, translateX = "0px", translateY = "0px", color = "blue", className = ""}: BlurShapeProps) {
    const isCentered = left === undefined && right === undefined
    return (
        <div
            className={`absolute rounded-full pointer-events-none -z-[1] ${className}`}
            style={{
                width,
                height,
                top,
                bottom,
                left: isCentered ? "50%" : left,
                right,
                transform: `translate(${isCentered ? `calc(-50% + ${translateX})` : translateX}, ${translateY})`,
                background: `radial-gradient(48.62% 48.96% at 50% 50%, ${BLUR_COLORS[color]} 0%, rgba(255, 255, 255, 0.00) 91.35%)`,
                filter: "blur(2px)",
            }}
            aria-hidden="true"
        />
    );
}
